<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="general content-wrapper">
      <div class="page-header" v-if="contactPersonStopSale === false">{{ $t('general') }}</div>
      <div class="page-header" v-if="contactPersonStopSale === true">{{ $t('stopSale') }}</div>
      <el-container>
        <el-main>
          <el-form ref="form" label-width="200px">
            <div class="form-group">
              <div class="title-group">
                {{$t('sender')}}
              </div>
              <el-form-item :label="$t('senderName')">
                <el-row>
                  <el-col :span="24">
                    <el-select v-model="emailData.selectedHotelId"
                               @change="onSelectSenderNameChange()"
                               style="width: 100%">
                      <el-option v-for="sender in senderList"
                                 :key="sender.hotelId"
                                 :label="`${sender.name} (${sender.hotelName})`"
                                 :value="sender.hotelId"></el-option>
                      <el-option :label="$t('otherSenderName')" value="0"></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <el-row v-if="emailData.selectedHotelId === '0'"
                        style="margin-top: 10px">
                  <el-col :span="24">
                    <el-input v-model="emailData.senderName"
                              :placeholder="$t('senderName')"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item :label="$t('replyEmail')">
                <el-row>
                  <el-col :span="24">
                    <el-input v-model="emailData.replyEmail"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </div>

            <div class="form-group">
              <div class="title-group">
                {{$t('recipient')}}
              </div>
              <el-form-item :label="$t('sendTo')">
                <el-radio-group v-model="emailData.sendTo">
                  <el-row>
                    <el-col :span="24">
                      <el-radio :label="1">{{ $t('allAgent') }}</el-radio>
                      <el-radio :label="2">{{ $t('specific') }}</el-radio>
                      <el-button plain size="small"
                                 :type="getSearchToSendButtonType"
                                 :disabled="isDisableSearchToSend"
                                 @click="onPopupAddHotelButtonClick">
                        {{ $t('searchToSend') }}
                      </el-button>
                    </el-col>
                  </el-row>
                </el-radio-group>
                <el-row v-if="emailData.sendTo !== 1">
                  <el-col :span="24" class="specific-send-to">
                    <el-row v-if="emailData.selectedMarketList.length > 0">
                      <el-col :span="3">
                        <strong style="color:#67C23A">{{ $t('market') }}: </strong>
                      </el-col>
                      <el-col :span="21">
                        <el-tag v-for="(item, index) in emailData.selectedMarketList"
                                v-show="index < 4"
                                :key="`${item.id}-${index}`"
                                size="small"
                                effect="plain"
                                class="specific-market">
                          {{item.name}}
                          <i class="el-icon-close icon-close-market"
                             @click="onRemoveMarketButtonClick(index)"></i>
                        </el-tag>
                        <pop-over-more-item-component
                          v-if="emailData.selectedMarketList.length > 4"
                          :data-list="emailData.selectedMarketList"
                          @onRemoveItem="onPopOverMoreMarketRemoveButtonClick"
                          list-type="market">
                        </pop-over-more-item-component>
                      </el-col>
                    </el-row>
                    <el-row v-if="emailData.selectedAgentTypeList.length > 0">
                      <el-col :span="3">
                        <strong style="color:#6A6D74">{{ $t('agentType') }}:</strong> </el-col>
                      <el-col :span="21">
                        <el-tag v-for="(item, index) in emailData.selectedAgentTypeList"
                                v-show="index < 4"
                                :key="`${item.id}-${index}`"
                                type="info"
                                size="small"
                                class="specific-agent-type">
                          {{item.name}}
                          <i class="el-icon-close" @click="onRemoveAgentTypeButtonClick(index)"></i>
                        </el-tag>
                        <pop-over-more-item-component
                          v-if="emailData.selectedAgentTypeList.length > 4"
                          :data-list="emailData.selectedAgentTypeList"
                          @onRemoveItem="onPopOverMoreAgentTypeRemoveButtonClick"
                          list-type="agentType">
                        </pop-over-more-item-component>
                      </el-col>
                    </el-row>
                    <el-row v-if="emailData.selectedAgentList.length > 0">
                      <el-col :span="3">
                        <strong style="color:#E6A23C">{{ $t('agent') }}:</strong>
                      </el-col>
                      <el-col :span="21">
                        <el-tag v-for="(item, index) in emailData.selectedAgentList"
                                v-show="index < 4"
                                :key="`${item.id}-${index}`"
                                type="primary"
                                size="small"
                                effect="plain"
                                class="specific-agent">
                          {{item.name}}
                          <i class="el-icon-close" @click="onRemoveAgentButtonClick(index)"></i>
                        </el-tag>
                        <pop-over-more-item-component
                          v-if="emailData.selectedAgentList.length > 4"
                          :data-list="emailData.selectedAgentList"
                          @onRemoveItem="onPopOverMoreAgentRemoveButtonClick"
                          list-type="agent">
                        </pop-over-more-item-component>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item :label="$t('includeAgentEmail')">
                <el-radio-group v-model="emailData.includeAgentEmail">
                  <el-row>
                    <el-col :span="24">
                      <el-radio :label="true">{{ $t('yes') }}</el-radio>
                      <el-radio :label="false">{{ $t('no') }}</el-radio>
                    </el-col>
                  </el-row>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('contactPersonOption')">
                <el-row>
                  <el-col :span="24">
                    <el-checkbox style="z-index: 0" v-model="emailData.contactPersonOption.primary">{{ $t('primary') }}</el-checkbox>
                    <el-checkbox style="z-index: 0" v-model="emailData.contactPersonOption.secondary"> {{ $t('secondary') }}</el-checkbox>
                    <el-checkbox style="z-index: 0" v-model="emailData.contactPersonOption.stopSale">{{ $t('stopSale') }}</el-checkbox>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item :label="$t('otherEmail')">
                <el-row>
                  <el-col :span="24">
                    <div v-if="inputOtherEmailVisible"
                         style="position: relative">
                      <div class="remark-other-email">
                        {{ $t('useCommaToSeparateEmailMessage') }}
                      </div>
                      <div style="width: 100%">
                        <el-input
                          v-model="emailData.otherEmail"
                          class="input-new-tag"
                          :placeholder="$t('addMoreEmail')"
                          ref="addOtherEmailInput"
                        ></el-input>
                      </div>
                    </div>
                    <el-button
                      v-else
                      plain
                      type="primary"
                      size="small"
                      @click="onAddMoreEmailButtonClick()">
                      + {{ $t('addMoreEmail') }}</el-button>
                  </el-col>
                </el-row>
              </el-form-item>
            </div>
            <div class="form-group" style="border-width: 0px; padding-top: 0px">
              <el-form-item :label="$t('subject')">
                <el-row>
                  <el-col :span="24">
                    <el-input v-model="emailData.subject"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item :label="$t('body')">
                <el-row>
                  <el-col :span="24">
                    <editor-component v-model="emailData.body"></editor-component>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item :label="$t('attachment')">
                <el-row>
                  <el-col :span="24">
                    <div>
                      <el-tag v-for="(item, index) in emailData.attachment"
                              :key="`${item.name}-${index}`"
                              type="info"
                              size="small"
                              class="file-item">
                        {{item.name}}
                        <i class="el-icon-close"
                           style="color: #4D585F"
                           @click="onRemoveAttachmentButtonClick(index)"></i>
                      </el-tag>
                    </div>
                    <div>
                      <div class="btn-upload">
                        <input class="upload"
                               type="file"
                               @change="getBase64"
                               ref="attachFile">
                        <el-button type="primary"
                                   plain
                                   size="small">
                          {{ $t('addAttachment') }}
                        </el-button>
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <small style="color: #f56c6c;">{{ $t('attachmentRemark') }}</small>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary"
                           @click="onSendButtonClick">
                  {{ $t('sendEmail') }}
                </el-button>
                <el-button type="default"
                           @click="onResetButtonClick">
                  {{ $t('reset') }}
                </el-button>
              </el-form-item>
            </div>
          </el-form>
        </el-main>
        <popup-search-to-send-component
          :agent-list="agentList"
          :market-list="marketList"
          :agent-type-list="agentTypeList"
          :selected-market-list="selectedMarketList"
          :selected-agent-type-list="selectedAgentTypeList"
          :selected-agent-list="selectedAgentList"
          :visible="isPopupSearchToSendVisible"
          @onClose="isPopupSearchToSendVisible = false"
          @onSaveChange="onPopupSearchToSendSuccess">
        </popup-search-to-send-component>
      </el-container>
    </div>
  </ContentContainer>
</template>

<script>
import i18nMessages from '@/translations/Email/ManageEmail/components/SendEmailFormComponent.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import ContentContainer from '@/components/ContentContainerComponent.vue'
import EditorComponent from '@/components/EditorComponent'
import { STATUS } from '@/configs/constant'
import PopupSearchToSendComponent from './PopupSearchToSendComponent'
import PopOverMoreItemComponent from './PopOverMoreItemComponent'
import AgentService from '@/services/agent-service'
import EmailApi from '@/api/email-api'
import { get } from 'lodash'

export default {
  name: 'SendEmailFormComponent',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { EditorComponent, ContentContainer, PopupSearchToSendComponent, PopOverMoreItemComponent },
  i18n: { messages: i18nMessages },
  props: {
    contactPersonPrimary: {
      type: Boolean,
      default: false
    },
    contactPersonSecondary: {
      type: Boolean,
      default: false
    },
    contactPersonStopSale: {
      type: Boolean,
      default: false
    },
    sendType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isLoading: false,
      isPopupSearchToSendVisible: false,
      emailData: {
        selectedHotelId: '',
        senderName: '',
        replyEmail: '',
        includeAgentEmail: false,
        contactPersonOption: {
          primary: false,
          secondary: false,
          stopSale: false
        },
        sendTo: 2,
        subject: '',
        body: '',
        attachment: [],
        selectedMarketList: [],
        selectedAgentTypeList: [],
        selectedAgentList: [],
        otherEmail: ''
      },
      hotelList: [],
      senderList: [],
      agentList: [],
      marketList: [],
      agentTypeList: [],
      selectedMarketList: [],
      selectedAgentTypeList: [],
      selectedAgentList: [],
      otherEmail: '',
      inputOtherEmailVisible: false
    }
  },
  created: async function () {
    try {
      this.isLoading = true

      this.emailData.contactPersonOption.primary = this.contactPersonPrimary
      this.emailData.contactPersonOption.secondary = this.contactPersonSecondary
      this.emailData.contactPersonOption.stopSale = this.contactPersonStopSale

      const result = await Promise.all([
        AgentService.getAgentList(),
        EmailApi.initData()
      ])

      const agentList = result[0]
      const emailResult = result[1]

      this.hotelList = emailResult.hotelList.sort((a, b) => {
        return (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1
      })

      this._prepareSenderList()
      this.emailData.selectedHotelId = get(this.senderList, '[0].hotelId', '')
      this.emailData.senderName = get(this.senderList, '[0].name', '')
      this.emailData.replyEmail = get(this.senderList, '[0].replyEmail', '')

      const filteredAgentList = agentList.filter(agent => (agent.isEnable === STATUS.ENABLE))
      this.agentList = filteredAgentList.sort((a, b) => {
        return (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1
      })
      this.marketList = emailResult.marketList.sort((a, b) => {
        return (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1
      })
      this.agentTypeList = emailResult.agentTypeList.sort((a, b) => {
        return (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1
      })
    } catch (err) {
      this.alertError(err.message)
    }

    this.isLoading = false
  },
  computed: {
    getSearchToSendButtonType: function () {
      return (this.emailData.sendTo === 1) ? 'info' : 'primary'
    },
    isDisableSearchToSend: function () {
      return (this.emailData.sendTo === 1)
    }
  },
  methods: {
    bindLabel: function (index, defaultLabel) {
      return (index === 0) ? defaultLabel : ''
    },
    onAddMoreItemButtonClick: function (keyItem) {
      this.emailData[keyItem].push('')
    },
    onRemoveItemButtonClick: function (keyItem, index) {
      this.emailData[keyItem].splice(index, 1)
    },
    onPopupAddHotelButtonClick: function () {
      this.selectedMarketList = [...this.emailData.selectedMarketList]
      this.selectedAgentTypeList = [...this.emailData.selectedAgentTypeList]
      this.selectedAgentList = [...this.emailData.selectedAgentList]
      this.isPopupSearchToSendVisible = true
    },
    onPopupSearchToSendSuccess: function (sendList) {
      this.emailData.selectedMarketList = [...sendList.marketList]
      this.emailData.selectedAgentTypeList = [...sendList.agentTypeList]
      this.emailData.selectedAgentList = [...sendList.agentList]
    },
    onRemoveMarketButtonClick: function (index) {
      this.emailData.selectedMarketList.splice(index, 1)
    },
    onRemoveAgentTypeButtonClick: function (index) {
      this.emailData.selectedAgentTypeList.splice(index, 1)
    },
    onRemoveAgentButtonClick: function (index) {
      this.emailData.selectedAgentList.splice(index, 1)
    },
    onPopOverMoreMarketRemoveButtonClick: function (index) {
      this.emailData.selectedMarketList.splice(index, 1)
    },
    onPopOverMoreAgentTypeRemoveButtonClick: function (index) {
      this.emailData.selectedAgentTypeList.splice(index, 1)
    },
    onPopOverMoreAgentRemoveButtonClick: function (index) {
      this.emailData.selectedAgentList.splice(index, 1)
    },
    onSendButtonClick: async function () {
      this.startLoading()
      try {
        if (!this._validate()) {
          this.stopLoading()
          return false
        }

        const data = this._prepareEmailData()
        await EmailApi.sendBulk(data)

        const title = this.$t('sendEmailSuccessTitle')
        const message = this.$t('sendEmailSuccessMessage')

        this.showNotificationSuccess(title, message)
        this._resetEmailData()
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    _prepareEmailData: function () {
      const agentList = this._getAgentList()
      const includeAgentEmail = get(this.emailData, 'includeAgentEmail', false)
      const primaryContactPerson = get(this.emailData, 'contactPersonOption.primary', false)
      const secondaryContactPerson = get(this.emailData, 'contactPersonOption.secondary', false)
      const stopSaleContactPerson = get(this.emailData, 'contactPersonOption.stopSale', false)
      const sendTo = this._prepareSendToList()

      const emailData = {
        hotelId: this.emailData.selectedHotelId,
        sendType: this.sendType,
        senderName: this.emailData.senderName,
        sendTo: sendTo,
        replyEmail: this.emailData.replyEmail,
        subject: this.emailData.subject,
        body: this.emailData.body,
        agentList: agentList,
        includeAgentEmail: this.emailData.includeAgentEmail,
        contactPersonOption: this.emailData.contactPersonOption,
        customEmailList: this.emailData.otherEmail.split(','),
        attachments: this.emailData.attachment,
        detail: {
          included: {
            agentEmail: includeAgentEmail,
            primaryContactPerson: primaryContactPerson,
            secondaryContactPerson: secondaryContactPerson,
            stopSaleContactPerson: stopSaleContactPerson
          }
        }
      }

      return emailData
    },
    _prepareSendToList: function () {
      const otherEmail = this.emailData.otherEmail.split(',').map(email => email.trim())
      const toEmailList = otherEmail.filter(email => (email !== ''))
      const selectedAgentList = (this.emailData.sendTo === 1) ? [] : this.emailData.selectedAgentList
      const selectedAgentTypeList = (this.emailData.sendTo === 1) ? [] : this.emailData.selectedAgentTypeList
      const selectedMarketList = (this.emailData.sendTo === 1) ? [] : this.emailData.selectedMarketList
      const agentNameList = selectedAgentList.map(agent => agent.name)
      const agentTypeNameList = selectedAgentTypeList.map(agentType => agentType.name)
      const marketNameList = selectedMarketList.map(market => market.name)

      const sendTo = {
        toList: toEmailList,
        isAllAgent: (this.emailData.sendTo === 1),
        agentList: agentNameList,
        agentTypeList: agentTypeNameList,
        marketList: marketNameList
      }

      return sendTo
    },
    onResetButtonClick: function () {
      this._resetEmailData()
    },
    _resetEmailData: function () {
      const selectedHotelId = get(this.senderList, '[0].hotelId', '')
      const senderName = get(this.senderList, '[0].name', '')
      const replyEmail = get(this.senderList, '[0].replyEmail', '')
      const contactPersonOption = {
        primary: this.contactPersonPrimary,
        secondary: this.contactPersonSecondary,
        stopSale: this.contactPersonStopSale
      }

      this.emailData = {
        selectedHotelId: selectedHotelId,
        senderName: senderName,
        replyEmail: replyEmail,
        includeAgentEmail: false,
        contactPersonOption: contactPersonOption,
        sendTo: 2,
        subject: '',
        body: '',
        attachment: [],
        selectedMarketList: [],
        selectedAgentTypeList: [],
        selectedAgentList: [],
        otherEmail: ''
      }
    },
    onRemoveAttachmentButtonClick: function (index) {
      this.emailData.attachment.splice(index, 1)
    },
    getBase64: function () {
      const input = event.target

      if (input.files && input.files[0]) {
        const fileSize = input.files[0].size

        if (this._overLimitFileSize(fileSize)) {
          input.value = ''
          this.alertError(this.$t('fileSizeOverMessage'))

          return false
        }

        const reader = new FileReader()
        reader.onload = (e) => {
          const attachFile = {
            name: input.files[0].name,
            content: e.target.result,
            size: input.files[0].size
          }
          this.emailData.attachment.push(attachFile)
          input.value = ''
        }

        reader.readAsDataURL(input.files[0])
      }
    },
    onAddMoreEmailButtonClick: function () {
      this.inputOtherEmailVisible = true
      this.$nextTick(_ => {
        this.$refs.addOtherEmailInput.$refs.input.focus()
      })
    },
    onSelectSenderNameChange: function () {
      if (this.emailData.selectedHotelId === '0') {
        this.emailData.replyEmail = ''
        this.emailData.senderName = ''
      } else {
        const sender = this.senderList.find((sender) => {
          return sender.hotelId === this.emailData.selectedHotelId
        })

        const replyEmail = get(sender, 'replyEmail', '')
        const senderName = get(sender, 'name', '')

        this.emailData.replyEmail = replyEmail
        this.emailData.senderName = senderName
      }
    },
    _overLimitFileSize: function (currentSize) {
      const MAX_FILE_SIZE = 3145728
      let totalFileSize = 0
      this.emailData.attachment.forEach((item) => {
        totalFileSize += item.size
      })
      totalFileSize += currentSize

      return (totalFileSize > MAX_FILE_SIZE)
    },
    _getAgentList: function () {
      const agentIdList = []

      if (this.emailData.sendTo === 1) {
        this.agentList.forEach((item) => {
          agentIdList.push(item.id)
        })
      } else {
        const agentIdListFromSelectedMarket = this._getAgentIdListFromSelectedMarket()
        agentIdList.push(...agentIdListFromSelectedMarket)

        const agentIdListFromSelectedAgentType = this._getAgentIdListFromSelectedAgentType()
        agentIdList.push(...agentIdListFromSelectedAgentType)

        const agentIdListFromSelectedAgent = this._getAgentIdListFromSelectedAgent()
        agentIdList.push(...agentIdListFromSelectedAgent)
      }

      const uniqAgentIdList = [...new Set(agentIdList)]
      const filteredAgentList = this.agentList.filter(agent => uniqAgentIdList.includes(agent.id))
      const agentList = filteredAgentList.map(agent => {
        const emailList = get(agent, 'information.emailList', [])
        const agentData = {
          id: agent.id,
          name: agent.name,
          information: {
            emailList: emailList
          }
        }

        return agentData
      })

      return agentList
    },
    _getAgentIdListFromSelectedMarket: function () {
      const agentIdList = []
      const selectedMarketId = []
      this.emailData.selectedMarketList.forEach((item) => {
        selectedMarketId.push(item.id)
      })

      this.marketList.forEach((market) => {
        if (selectedMarketId.includes(market.id) === true) {
          agentIdList.push(...market.agentIdList)
        }
      })

      return agentIdList
    },
    _getAgentIdListFromSelectedAgentType: function () {
      const agentIdList = []
      const selectedAgentTypeId = []
      this.emailData.selectedAgentTypeList.forEach((item) => {
        selectedAgentTypeId.push(item.id)
      })
      this.agentList.forEach((item) => {
        const agentTypeId = get(item, 'agentTypeId', '')
        if (selectedAgentTypeId.includes(agentTypeId) === true) {
          agentIdList.push(item.id)
        }
      })

      return agentIdList
    },
    _getAgentIdListFromSelectedAgent: function () {
      const selectedAgentId = []
      this.emailData.selectedAgentList.forEach((item) => {
        selectedAgentId.push(item.id)
      })

      return selectedAgentId
    },
    _prepareSenderList: function () {
      const senderList = this.hotelList.map((hotel) => {
        const hotelName = get(hotel, 'name', '')
        const emailSenderName = get(hotel, 'senderName', '')
        const replyEmail = get(hotel, 'replyEmail', '')
        const senderName = (emailSenderName === '') ? hotelName : emailSenderName

        const result = {
          hotelId: hotel.id,
          name: senderName,
          hotelName: hotelName,
          replyEmail: replyEmail
        }

        return result
      })

      senderList.sort((pre, next) => {
        return (pre.name.toLowerCase() > next.name.toLowerCase()) ? 1 : -1
      })

      this.senderList = senderList
    },
    _validate: function () {
      if (this.emailData.replyEmail === '') {
        this.alertError(this.$t('emptyReplyEmailErrorMessage'))
        return false
      }

      if (this._getAgentList().length !== 0 &&
        this.emailData.includeAgentEmail === false &&
        this.emailData.contactPersonOption.primary === false &&
        this.emailData.contactPersonOption.secondary === false &&
        this.emailData.contactPersonOption.stopSale === false &&
        this.emailData.otherEmail.trim() === '') {
        this.alertError(this.$t('notSelectContactPersonOptionErrorMessage'))
        return false
      }

      if (this._getAgentList().length === 0 && this.emailData.otherEmail.trim() === '') {
        this.alertError(this.$t('notSelectAgentErrorMessage'))
        return false
      }

      if (this.emailData.subject.trim() === '') {
        this.alertError(this.$t('emptyEmailSubjectErrorMessage'))
        return false
      }

      if (this.emailData.body.trim() === '') {
        this.alertError(this.$t('emptyEmailBodyErrorMessage'))
        return false
      }

      return true
    }
  }
}
</script>

<style scoped>
  .el-header {
    background-color: #f8f9fa;
    color: #2c3e50;
    text-align: center;
    line-height: 60px;
    font-weight: bold;
  }
  .el-container {
    width: 80%;
    margin: 0 auto;
  }
  .company-logo {
    border: 0 !important;
    margin: 0 auto 20px;
    text-align: center;
  }

  .el-radio-group {
    width: 100%;
  }

  .el-radio-group .el-col {
    padding-top: 8px;
  }

  .el-radio-group .el-col.el-col-10 {
    padding-top: 0;
  }

  .row-footer {
    border: 0;
    text-align: center;
    margin-top: 20px;
  }

  div.btn-upload {
    overflow: hidden;
    text-align: center;
    position: relative;
    line-height: 50px;
    margin: 0px;
    height: 50px;
    float: left;
    transition: all ease 0.2s;
  }

  input.upload {
    bottom: 0px;
    right: 0px;
    opacity: 0;
    width: 100%;
    height: 100%;
    outline: none;
    cursor: pointer;
    position: absolute;
  }
  .remove-file-icon {
    padding: 2px;
    margin-left: 5px;
    border-radius: 10px;
    background: #f00;
    color: #fff;
  }
  .specific-send-to {
    margin-top: 20px;
    padding-left: 20px;
    border: solid;
    border-width: 0px;
    border-left-width: 2px;
    border-color: #ccc;
  }
  .specific-market {
    color: #4D585F !important;
    background: #CAEFB8 !important;
    border-color: #CAEFB8 !important;
    margin-right: 5px
  }
  .specific-agent-type {
    color: #4D585F !important;
    background: #E5E8EF !important;
    border-color: #E5E8EF !important;
    margin-right: 5px
  }
  .specific-agent {
    color: #4D585F !important;
    background: #FADBA8 !important;
    border-color: #FADBA8 !important;
    margin-right: 5px
  }
  .icon-close-market {
    color: #2E7B09 !important;
  }
  .el-icon-close {
    background-color: #FFFFFF !important;
    font-weight: bold;
  }
  .el-tag {
    border-radius: 25px !important;
  }
  .file-item {
    color: #ffffff !important;
    background: #409EFF !important;
    border-color: #409EFF !important;
    margin-right: 5px
  }
  .form-group {
    border: solid 1px #d0e5fb;
    border-radius: 5px;
    padding: 40px 40px 10px 0px;
    margin-bottom: 60px;
    position: relative;
  }
  .title-group {
    position: absolute;
    text-align: right;
    top:-20px;
    left: 100px;
    background: #FFFFFF;
    padding: 9px 10px;
    color: #409EFF;
    font-size: 15px;
    text-transform: uppercase;
  }
  .remark-other-email {
    width: 100%;
    text-align: right;
    position: absolute;
    z-index: 10; top: -30px;
    color: #9e9e9e;
  }
</style>
